import qc from 'qc'
import { findByUuid } from '@ps/bridge/qc/node/utils'
import { ClipboardType, emptyClipboard, setClipboard } from './index'
import { getStyle } from './style'
import { getAnimationScripts } from './animation'
import { getEvent } from './event'
import { getSceneNodeByUuid } from '@ps/bridge/qc/base'
import { AstEventItem } from '@ps/bridge/qc/scripts/editor'
import { getLayout } from '@ps/workbench/copy-paste/layout'
import { getVpAstFromSceneNode } from '@ps/bridge/qc/vp'

export function copyNode(nodes: qc.Node[]): void {
  emptyClipboard()

  let clipboard: ClipboardType = {}
  // 复制时的节点顺序和选取节点操作的顺序刚好相反
  clipboard.nodes = nodes.reverse()
    .map(node => findByUuid(node.uuid))
    .filter(Boolean) as qc.Node[]

  // 复制一个节点时，才需要关注事件、动画样式这些逻辑
  if (clipboard.nodes && clipboard.nodes.length === 1) {
    const node = clipboard.nodes[0]
    const scene = getSceneNodeByUuid(node.uuid) as qc.Node
    const vpAst = getVpAstFromSceneNode(scene) as AstEventItem[]
    clipboard = {
      ...clipboard,
      originalNode: node,
      animation: getAnimationScripts({ node }),
      event: getEvent({ node, vpAst }),
      positionAndSize: getLayout(node),
      style: getStyle(node)
    }
  }
  setClipboard(clipboard)
}
